import { useCallback } from "react";
import { InputText } from "primereact/inputtext"
import { unMask, mask as applyMask } from 'remask';

export const MaskedInput = ({
  label, children, error, value = '', onChange: _onChange, mask, charAcceptRegex, maskPlaceholder, currency, ...rest
}) => {
  const hasMask = !!mask;

  const handleOnChange = useCallback(
    (e) => {
      let value = e.target.value;

      const toCurrency = () => {
        const tempValue = Number(value.replace(/\D/g, '') ?? '0');
        if (tempValue.toString().length === 1) {
          (e.target).value = `0,0${tempValue}`;
        } else if (tempValue.toString().length === 2) {
          (e.target).value = `0,${tempValue}`;
        } else if (tempValue.toString().length > 2) {
          (e.target).value = Number(tempValue / 100).toLocaleString('pt-BR', { minimumFractionDigits: 2 });
        }
        value = (e.target).value;
      };

      // when press backspace, no masking is needed
      if (e.nativeEvent.inputType === 'deleteContentBackward') {
        if (currency) toCurrency();

        return _onChange?.(value);
      }

      if (!currency) {
        if (hasMask) {
          const unMasked = unMask(value);
          const masked = applyMask(unMasked, mask, {
            placeholder: maskPlaceholder,
          });
          value = masked;
        } else if (charAcceptRegex) {
          if (!value.match(charAcceptRegex)) {
            value = value.slice(0, -1);
            e.target.value = value;
          }
        }
      } else if (currency) toCurrency();

      _onChange?.(value);
    },
    [_onChange, hasMask, mask, maskPlaceholder, charAcceptRegex, currency],
  );


  return <InputText
    onChange={handleOnChange}
    value={value}
    {...(error && { invalid: true })}
    {...rest}
  />
}